import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { showToast } from '../../components/Toast';

const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    showToast('Payment cancelled', 'info', 'You can retry the payment anytime');
  }, []);

  return (
    <div className="min-h-screen bg-[#09140F] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-[#16251D] border border-gray-800 rounded-lg p-8 text-center">
          <div className="flex justify-center mb-6">
            <XCircle size={48} className="text-yellow-500" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h1>
          <p className="text-gray-400 mb-6">
            You cancelled the payment. The member has been created with a trial subscription and you can retry the payment anytime.
          </p>
          <div className="space-y-3">
            <button
              onClick={() => navigate('/members')}
              className="w-full bg-[#23F47C] text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition-all"
            >
              Back to Members
            </button>
            <button
              onClick={() => navigate('/members/add')}
              className="w-full bg-gray-800 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-all border border-gray-700"
            >
              Add Another Member
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
